import { render } from "./ValueDetails.vue?vue&type=template&id=85176312&scoped=true"
import script from "./ValueDetails.vue?vue&type=script&lang=js"
export * from "./ValueDetails.vue?vue&type=script&lang=js"

import "./ValueDetails.vue?vue&type=style&index=0&id=85176312&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85176312"]])

export default __exports__